import dateformat = require("dateformat");

/**
 * Converts a UTC to a localized date and time string.
 */
export function getLocalizedDate(utcDate: string | number | Date, withTimeString: boolean) {
	const date = new Date(utcDate);

	//Time formatting data at: http://blog.stevenlevithan.com/archives/date-time-format

	if (withTimeString) {
		return dateformat(date, "mmm d, h:MM TT Z");
	}

	return dateformat(date, "mmm d, yyyy");
}
